import * as cnames from 'classnames'
import * as React from 'react'

import { IItemCard } from '../interface'

import ItemCardContentWithAttributesAndFiles from '../itemCardContentWithAttributesAndFiles'
import ItemCardSidebar from '../itemCardSidebar'
import ItemCardSquarePreview from '../itemCardSquarePreview'

import * as styles from './graphicRiverItemCard.module.css'

interface IState {
  collapsed: boolean
}

class GraphicRiverItemCard extends React.Component<IItemCard, IState> {
  public render() {
    const { viewType } = this.props

    const rootClass = cnames(styles.root, {
      [styles.listView]: viewType === 'list',
      [styles.gridView]: viewType !== 'list'
    })

    return (
      <div className={rootClass}>
        <article className={styles.card}>
          <section className={styles.preview}>
            <ItemCardSquarePreview
              opaqueOnHoverClass={styles.opaqueOnHover}
              {...this.props}
            />
          </section>
          <section className={styles.content}>
            <ItemCardContentWithAttributesAndFiles {...this.props} />
          </section>
          <section className={styles.sidebar}>
            <ItemCardSidebar {...this.props} />
          </section>
        </article>
      </div>
    )
  }
}

export default GraphicRiverItemCard
